import React from 'react';
import { PropTypes, describe } from '@elliemae/ds-props-helpers';
import { DSCircularProgressIndicator } from '@elliemae/ds-circular-progress-indicator';
import { useTheme } from '@elliemae/ds-system';
import { useSwipe } from './useSwipe.js';
import { SwipeContainer, SwipeDrag, LoaderBox, PositionLoader } from './styled.js';
import { ProgressIndicator } from './ProgressIndicator.js';

const SwipeToRefresh = ({ children, loading, onRefresh }) => {
  const breakpoint = 60;
  const theme = useTheme();
  const swipe = useSwipe({ onRefresh, breakpoint });
  const progress = swipe.height > breakpoint ? 100 : (swipe.height * 100) / breakpoint;
  return (
    <SwipeContainer>
      <SwipeDrag
        onTouchStart={swipe.touchStart}
        onTouchEnd={swipe.touchEnd}
        onTouchCancel={swipe.touchCancel}
        onTouchMove={swipe.touchMove}
        innerRef={swipe.ref}
      >
        <LoaderBox
          height={loading ? theme.space.m : `${swipe.height}px`}
          alignItems="flex-start"
          data-testid="loader-box"
        >
          <PositionLoader
            height={theme.space.m}
            justifyContent="center"
            alignItems="center"
            mt={swipe.height > 40 || loading ? 0 : `${swipe.height - 40}px`}
          >
            {loading ? <DSCircularProgressIndicator /> : <ProgressIndicator progress={progress} />}
          </PositionLoader>
        </LoaderBox>
        <div ref={swipe.target} style={{ height: 1 }} />
        {children}
      </SwipeDrag>
    </SwipeContainer>
  );
};

const props = {
  /** component inside swipe to refresh container */
  children: PropTypes.element.isRequired.description('component inside swipe to refresh container'),
  /** toggle loading state for swipe */
  loading: PropTypes.bool.description('toggle loading state for swipe'),
  /** callback on refresh swipe */
  onRefresh: PropTypes.func.description('callback on refresh swipe'),
};

SwipeToRefresh.displayName = 'SwipeToRefresh';
const SwipeToRefreshWithSchema = describe(SwipeToRefresh);

SwipeToRefreshWithSchema.propTypes = props;

export { SwipeToRefresh, SwipeToRefreshWithSchema };
